const GAP = 6;

class InfoPopoverElement extends HTMLElement {
  connectedCallback() {
    this._button = this.querySelector('.info-popover__button');
    this._content = this.querySelector('.info-popover__content');
    this._resizeObserver = new ResizeObserver(this._position);
    this._content.addEventListener('toggle', this._handleToggle);
  }

  disconnectedCallback() {
    this._content?.removeEventListener('toggle', this._handleToggle);
    this._stopTracking();
  }

  _handleToggle = (event) => {
    if (event.newState === 'open') {
      this._position();
      this._resizeObserver.observe(this._content);
      window.addEventListener('resize', this._position);
    } else {
      this._stopTracking();
    }
  };

  _stopTracking() {
    this._resizeObserver?.disconnect();
    window.removeEventListener('resize', this._position);
  }

  // Popovers render in the top layer, outside the image container, so they're positioned
  // against the document to sit beside the button, bottom-aligned with it.
  _position = () => {
    const button = this._button.getBoundingClientRect();
    const content = this._content.getBoundingClientRect();
    const left = button.left + window.scrollX - GAP - content.width;
    const top = button.bottom + window.scrollY - content.height;
    this._content.style.left = `${left}px`;
    this._content.style.top = `${top}px`;
  };
}

customElements.define('chh-info-popover', InfoPopoverElement);

export default InfoPopoverElement;
